/* RESPONSIBLE TEAM: team-actions */

import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';
import type RouterService from '@ember/routing/router-service';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import type AppService from 'embercom/services/app-service';

class StandaloneProceduresRoute extends Route {
  @service declare intl: IntlService;
  @service declare appService: AppService;
  @service declare router: RouterService;
  @service declare notificationsService: any;

  async beforeModel() {
    if (!this.appService.app?.canUseProceduresClosedBeta) {
      this.router.transitionTo('apps.app.standalone.tasks');
    }
  }

  get titleToken() {
    return this.intl.t('ai-agent.new-submenu.procedures');
  }

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(StandaloneProceduresRoute, { overrideRenderTemplate: false });
